import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { signInWithCustomToken } from 'redux/actions/Auth';
import { APP_PREFIX_PATH } from 'configs/AppConfig';

const LtiSso = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [status, setStatus] = useState('processing');
  const [tokenDispatched, setTokenDispatched] = useState(false);
  
  // Listen to authentication state from Redux
  const token = useSelector(state => state.auth.token);
  const loading = useSelector(state => state.auth.loading);

  console.log('[LtiSso] Component loaded');
  console.log('[LtiSso] Redux state - token:', token, 'loading:', loading);

  useEffect(() => {
    console.log('[LtiSso] First useEffect running');
    const params = new URLSearchParams(window.location.search);
    const customToken = params.get('token');
    console.log('[LtiSso] Custom token from URL:', customToken ? 'present' : 'missing');
    
    if (!customToken) {
      console.log('[LtiSso] No token found, redirecting to login');
      setStatus('missing');
      // Redirect to login
      setTimeout(() => history.replace('/auth/login'), 800);
      return;
    }

    // Dispatch the saga action to sign in with custom token
    if (!tokenDispatched) {
      console.log('[LtiSso] Dispatching signInWithCustomToken');
      dispatch(signInWithCustomToken(customToken));
      setTokenDispatched(true);
      // Remove token from URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [dispatch, history, tokenDispatched]);

  // Redirect once authenticated (token set and not loading)
  useEffect(() => {
    console.log('[LtiSso] Second useEffect - tokenDispatched:', tokenDispatched, 'token:', token, 'loading:', loading);
    if (tokenDispatched && token && !loading) {
      console.log('[LtiSso] Authentication complete, redirecting to app');
      setStatus('signed-in');
      setTimeout(() => history.replace(APP_PREFIX_PATH), 300);
    }
  }, [token, loading, tokenDispatched, history]);

  return (
    <div style={{ padding: 40 }}>
      {status === 'processing' && <h3>Procesando inicio de sesión LTI...</h3>}
      {status === 'missing' && <h3>Token LTI no encontrado. Redirigiendo al inicio de sesión.</h3>}
      {status === 'signed-in' && <h3>Inicio de sesión completado. Redirigiendo...</h3>}
    </div>
  );
};

export default LtiSso;
